import React from 'react';
import { Input } from '@flixbus/honeycomb-react';

import { Asterisk } from '../../Asterisk';
import { useVoucherFormContext } from '../../Context';

import useOnMount from '../../../../hooks/useInit';

const VoucherFormPercentageMarketing = () => {
  const DEFAULT_DISCOUNT_TYPE = {
    type: 'percentage_marketing',
    percentage: 0.3,
  };

  const {
    formState: {
      payload: { discountType },
    },
    handlePayloadChange,
  } = useVoucherFormContext();

  useOnMount(() => handlePayloadChange({ value: DEFAULT_DISCOUNT_TYPE, prop: 'discountType' }));

  return (
    <div>
      <Input
        name='percentage-marketing'
        id='percentage-marketing'
        label={
          <>
            Percentage <Asterisk />
          </>
        }
        type='number'
        step={10}
        max={100}
        min={0}
        required
        value={(discountType.percentage
          ? parseFloat((discountType.percentage * 100).toFixed(10))
          : 0
        ).toString()}
        onChange={e => {
          const parsedValue = e.target.value === '' ? 0 : parseFloat(e.target.value);
          const finalValue = isNaN(parsedValue) ? 0 : Math.min(Math.max(parsedValue, 0), 100);

          handlePayloadChange({
            value: {
              type: 'percentage_marketing',
              percentage: finalValue / 100,
            },
            prop: 'discountType',
          });
        }}
      />
    </div>
  );
};

export default VoucherFormPercentageMarketing;
